import { getDaysInMonth } from 'date-fns';

export const MIN_BIRTHDAY_YEAR = 1900;

export const digitsOnly = (value: string) => value.replace(/\D/g, '');

export const isValidBirthdayMonth = (month: string) => {
  const value = parseInt(month, 10);
  return value >= 1 && value <= 12;
};

export const isValidBirthdayYear = (year: string) => {
  const value = parseInt(year, 10);
  return (
    year.length === 4 &&
    value >= MIN_BIRTHDAY_YEAR &&
    value <= new Date().getFullYear()
  );
};

export const isValidBirthdayDay = (
  day: string,
  month: string,
  year: string,
) => {
  const value = parseInt(day, 10);
  if (!(value >= 1)) return false;
  if (!isValidBirthdayMonth(month) || !isValidBirthdayYear(year)) {
    return value <= 31;
  }
  return (
    value <=
    getDaysInMonth(new Date(parseInt(year, 10), parseInt(month, 10) - 1))
  );
};

export const buildBirthdayIsoString = (
  month: string | undefined,
  year: string | undefined,
  day: string | undefined,
) => {
  if (
    !isValidBirthdayMonth(month ?? '') ||
    !isValidBirthdayYear(year ?? '') ||
    !isValidBirthdayDay(day ?? '', month ?? '', year ?? '')
  ) {
    return '';
  }

  const date = new Date(
    parseInt(year as string, 10),
    parseInt(month as string, 10) - 1,
    parseInt(day as string, 10),
  );
  return date > new Date() ? '' : date.toISOString();
};

// Stored birthdays are UTC midnight; drop the zone so the displayed day doesn't shift.
export const parseBirthdayValue = (value: string | Date | undefined | null) => {
  if (!value) return undefined;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return undefined;
  return new Date(date.toISOString().replace('Z', ''));
};
